import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-start pt-8 overflow-hidden" data-id="element-69">
      {/* Background ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-brand-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-70" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center mt-4 md:mt-8 pl-[16px] pr-[16px]" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-72">
          <h1 className="md:text-6xl lg:text-7xl font-black text-brand-white mb-6 uppercase text-[36px]" data-id="element-73">
            ¿Te despiertas a las 2 AM <br className="hidden md:block" data-id="element-74" />
            solo para revisar si está{' '}
            <span className="text-brand-red text-glow-red" data-id="element-75">"en línea"</span>?
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-76">
          <p className="text-xl md:text-2xl text-brand-gray max-w-3xl mx-auto font-light leading-relaxed mb-12" data-id="element-77">
            El protocolo de 30 días para recuperar tu dignidad, hackear tu
            adicción digital y dejar de mendigar atención{' '}
            <span className="text-brand-white font-medium" data-id="element-78">
              (sin juegos de manipulación)
            </span>
            .
          </p>
        </motion.div>
      </div>

      <motion.div className="relative w-full max-w-6xl mx-auto mt-8 md:mt-16 px-4" initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1,
      delay: 0.4,
      ease: 'easeOut'
    }} data-id="element-79">
        <div className="relative rounded-2xl overflow-hidden border border-white/5 box-glow-gold" data-id="element-80">
          <img src="https://cdn.magicpatterns.com/uploads/5Qx3UPkjxQ63zUK4TUdrvS/heylloyd-image-1773981291933.png" alt="CeroRastro Protocol on a dark desk at night" className="w-full h-auto object-cover opacity-90" data-id="element-81" />
          {/* Gradient overlays to blend image into background */}
          <div className="absolute inset-0 bg-gradient-to-t from-brand-black via-brand-black/20 to-transparent" data-id="element-82" />
          <div className="absolute inset-0 bg-gradient-to-x from-brand-black via-transparent to-brand-black opacity-50" data-id="element-83" />
        </div>
      </motion.div>
    </section>;
}